"use strict";
/**
 * @packageDocumentation
 * @module MessageUtils
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.decompressMessage = exports.compressMessage = exports.verifyRequiredCTypeProperties = exports.errorCheckMessage = exports.errorCheckMessageBody = exports.errorCheckDelegationData = void 0;
const tslib_1 = require("tslib");
const core_1 = require("@kiltprotocol/core");
const utils_1 = require("@kiltprotocol/utils");
const util_1 = require("@polkadot/util");
const _1 = tslib_1.__importDefault(require("."));
// Had to add the check as differs from the delegation types
function errorCheckDelegationData(delegationData) {
    const { permissions, id, parentId, isPCR, account } = delegationData;
    if (!id) {
        throw utils_1.SDKErrors.ERROR_DELEGATION_ID_MISSING();
    }
    else if (typeof id !== 'string') {
        throw utils_1.SDKErrors.ERROR_DELEGATION_ID_TYPE();
    }
    else if (!util_1.isHex(id)) {
        throw utils_1.SDKErrors.ERROR_DELEGATION_ID_TYPE();
    }
    if (!account) {
        throw utils_1.SDKErrors.ERROR_OWNER_NOT_PROVIDED();
    }
    else
        utils_1.DataUtils.validateAddress(account, 'delegationNode owner');
    if (typeof isPCR !== 'boolean') {
        throw new TypeError('isPCR is expected to be a boolean');
    }
    if (permissions.length === 0 || permissions.length > 3) {
        throw utils_1.SDKErrors.ERROR_UNAUTHORIZED('Must have at least one permission and no more then two');
    }
    if (parentId) {
        if (typeof parentId !== 'string') {
            throw utils_1.SDKErrors.ERROR_DELEGATION_ID_TYPE();
        }
        else if (!util_1.isHex(parentId)) {
            throw utils_1.SDKErrors.ERROR_DELEGATION_ID_TYPE();
        }
    }
}
exports.errorCheckDelegationData = errorCheckDelegationData;
function errorCheckMessageBody(body) {
    switch (body.type) {
        case _1.default.BodyType.REQUEST_TERMS: {
            core_1.ClaimUtils.errorCheck(body.content);
            break;
        }
        case _1.default.BodyType.SUBMIT_TERMS: {
            core_1.ClaimUtils.errorCheck(body.content.claim);
            body.content.legitimations.map((attestedClaim) => core_1.AttestedClaimUtils.errorCheck(attestedClaim));
            if (body.content.delegationId) {
                utils_1.DataUtils.validateHash(body.content.delegationId, 'Submit terms delegation id hash invalid');
            }
            if (body.content.quote) {
                core_1.Quote.validateQuoteSchema(core_1.QuoteSchema, body.content.quote);
            }
            if (body.content.prerequisiteClaims) {
                utils_1.DataUtils.validateHash(body.content.prerequisiteClaims, 'Submit terms pre-requisite claims invalid');
            }
            if (body.content.cTypes) {
                body.content.cTypes.map((val) => core_1.CTypeUtils.errorCheck(val));
            }
            break;
        }
        case _1.default.BodyType.REJECT_TERMS: {
            core_1.ClaimUtils.errorCheck(body.content.claim);
            if (body.content.delegationId) {
                utils_1.DataUtils.validateHash(body.content.delegationId, 'Reject terms delegation id hash');
            }
            body.content.legitimations.map((val) => core_1.AttestedClaimUtils.errorCheck(val));
            break;
        }
        case _1.default.BodyType.REQUEST_ATTESTATION_FOR_CLAIM: {
            core_1.RequestForAttestationUtils.errorCheck(body.content.requestForAttestation);
            if (body.content.quote) {
                core_1.Quote.validateQuoteSchema(core_1.QuoteSchema, body.content.quote);
            }
            if (body.content.prerequisiteClaims) {
                body.content.prerequisiteClaims.map((claim) => core_1.ClaimUtils.errorCheck(claim));
            }
            break;
        }
        case _1.default.BodyType.SUBMIT_ATTESTATION_FOR_CLAIM: {
            core_1.AttestationUtils.errorCheck(body.content.attestation);
            break;
        }
        case _1.default.BodyType.REJECT_ATTESTATION_FOR_CLAIM: {
            if (!util_1.isHex(body.content)) {
                throw utils_1.SDKErrors.ERROR_HASH_MALFORMED();
            }
            break;
        }
        case _1.default.BodyType.REQUEST_CLAIMS_FOR_CTYPES: {
            body.content.forEach((requestClaimsForCTypes) => {
                var _a, _b;
                utils_1.DataUtils.validateHash(requestClaimsForCTypes.cTypeHash, 'request claims for ctypes cTypeHash invalid');
                (_a = requestClaimsForCTypes.acceptedAttester) === null || _a === void 0 ? void 0 : _a.map((address) => utils_1.DataUtils.validateAddress(address, 'request claims for ctypes attester approved addresses invalid'));
                (_b = requestClaimsForCTypes.requiredProperties) === null || _b === void 0 ? void 0 : _b.map((requiredProps) => {
                    if (typeof requiredProps !== 'string')
                        throw new TypeError('required properties is expected to be a string');
                });
            });
            break;
        }
        case _1.default.BodyType.SUBMIT_CLAIMS_FOR_CTYPES: {
            body.content.map((attestedClaim) => core_1.AttestedClaimUtils.errorCheck(attestedClaim));
            break;
        }
        case _1.default.BodyType.ACCEPT_CLAIMS_FOR_CTYPES: {
            body.content.map((cTypeHash) => utils_1.DataUtils.validateHash(cTypeHash, 'accept claims for ctypes message ctype hash invalid'));
            break;
        }
        case _1.default.BodyType.REJECT_CLAIMS_FOR_CTYPES: {
            body.content.map((cTypeHash) => utils_1.DataUtils.validateHash(cTypeHash, 'rejected claims for ctypes ctype hashes invalid'));
            break;
        }
        case _1.default.BodyType.REQUEST_ACCEPT_DELEGATION: {
            errorCheckDelegationData(body.content.delegationData);
            if (!util_1.isHex(body.content.signatures.inviter)) {
                throw utils_1.SDKErrors.ERROR_SIGNATURE_DATA_TYPE();
            }
            if (!util_1.isJsonObject(body.content.metaData)) {
                throw utils_1.SDKErrors.ERROR_OBJECT_MALFORMED();
            }
            break;
        }
        case _1.default.BodyType.SUBMIT_ACCEPT_DELEGATION: {
            errorCheckDelegationData(body.content.delegationData);
            if (!util_1.isHex(body.content.signatures.invitee) ||
                !util_1.isHex(body.content.signatures.inviter)) {
                throw utils_1.SDKErrors.ERROR_SIGNATURE_DATA_TYPE();
            }
            break;
        }
        case _1.default.BodyType.REJECT_ACCEPT_DELEGATION: {
            errorCheckDelegationData(body.content);
            break;
        }
        case _1.default.BodyType.INFORM_CREATE_DELEGATION: {
            utils_1.DataUtils.validateHash(body.content.delegationId, 'inform create delegation message delegation id invalid');
            break;
        }
        default:
            throw utils_1.SDKErrors.ERROR_MESSAGE_BODY_MALFORMED();
    }
    return true;
}
exports.errorCheckMessageBody = errorCheckMessageBody;
function errorCheckMessage(message) {
    const { body, messageId, createdAt, receiverAddress, senderAddress, receivedAt, senderBoxPublicKey, inReplyTo, } = message;
    if (messageId && typeof messageId !== 'string') {
        throw new TypeError('message id is expected to be a string');
    }
    if (createdAt && typeof createdAt !== 'number') {
        throw new TypeError('created at is expected to be a number');
    }
    if (receivedAt && typeof receivedAt !== 'number') {
        throw new TypeError('received at is expected to be a number');
    }
    utils_1.DataUtils.validateAddress(receiverAddress, 'receiver address');
    utils_1.DataUtils.validateAddress(senderAddress, 'sender address');
    if (!util_1.isHex(senderBoxPublicKey)) {
        throw utils_1.SDKErrors.ERROR_ADDRESS_INVALID();
    }
    if (inReplyTo && typeof inReplyTo !== 'string') {
        throw new TypeError('in reply to is expected to be a string');
    }
    errorCheckMessageBody(body);
    return true;
}
exports.errorCheckMessage = errorCheckMessage;
/**
 * Verifies required properties for a given [[CType]] before sending or receiving a message.
 *
 * @param requiredProperties The list of required properties that need to be verified against a [[CType]].
 * @param cType A [[CType]] used to verify the properties.
 * @throws [[ERROR_CTYPE_HASH_NOT_PROVIDED]] when the properties do not match the provide [[CType]].
 *
 * @returns Returns the properties back.
 */
function verifyRequiredCTypeProperties(requiredProperties, cType) {
    core_1.CTypeUtils.errorCheck(cType);
    const validProperties = requiredProperties.find((property) => !(property in cType.schema.properties));
    if (validProperties) {
        throw utils_1.SDKErrors.ERROR_CTYPE_PROPERTIES_NOT_MATCHING();
    }
    return true;
}
exports.verifyRequiredCTypeProperties = verifyRequiredCTypeProperties;
/**
 * Compresses a [[Message]] depending on the message body type.
 *
 * @param body The body of the [[Message]] which depends on the [[MessageBodyType]] that needs to be compressed.
 *
 * @returns Returns the compressed message optimised for sending.
 */
function compressMessage(body) {
    var _a;
    let compressedContents;
    switch (body.type) {
        case _1.default.BodyType.REQUEST_TERMS: {
            compressedContents = core_1.ClaimUtils.compress(body.content);
            break;
        }
        case _1.default.BodyType.SUBMIT_TERMS: {
            compressedContents = [
                core_1.ClaimUtils.compress(body.content.claim),
                body.content.legitimations.map((attestedClaim) => Array.isArray(attestedClaim)
                    ? attestedClaim
                    : core_1.AttestedClaimUtils.compress(attestedClaim)),
                body.content.delegationId,
                body.content.quote
                    ? core_1.QuoteUtils.compressAttesterSignedQuote(body.content.quote)
                    : undefined,
                body.content.prerequisiteClaims,
                (_a = body.content.cTypes) === null || _a === void 0 ? void 0 : _a.map((val) => core_1.CTypeUtils.compress(val)),
            ];
            break;
        }
        case _1.default.BodyType.REJECT_TERMS: {
            compressedContents = [
                core_1.ClaimUtils.compress(body.content.claim),
                body.content.legitimations.map((val) => core_1.AttestedClaimUtils.compress(val)),
                body.content.delegationId || undefined,
            ];
            break;
        }
        case _1.default.BodyType.REQUEST_ATTESTATION_FOR_CLAIM: {
            compressedContents = [
                core_1.RequestForAttestationUtils.compress(body.content.requestForAttestation),
                body.content.quote
                    ? core_1.QuoteUtils.compressQuoteAgreement(body.content.quote)
                    : undefined,
                body.content.prerequisiteClaims
                    ? body.content.prerequisiteClaims.map((claim) => core_1.ClaimUtils.compress(claim))
                    : undefined,
            ];
            break;
        }
        case _1.default.BodyType.SUBMIT_ATTESTATION_FOR_CLAIM: {
            compressedContents = core_1.AttestationUtils.compress(body.content.attestation);
            break;
        }
        case _1.default.BodyType.REQUEST_CLAIMS_FOR_CTYPES: {
            compressedContents = body.content.map((val) => {
                return [val.cTypeHash, val.acceptedAttester, val.requiredProperties];
            });
            break;
        }
        case _1.default.BodyType.SUBMIT_CLAIMS_FOR_CTYPES: {
            compressedContents = body.content.map((attestedClaim) => Array.isArray(attestedClaim)
                ? attestedClaim
                : core_1.AttestedClaimUtils.compress(attestedClaim));
            break;
        }
        case _1.default.BodyType.REQUEST_ACCEPT_DELEGATION: {
            compressedContents = [
                [
                    body.content.delegationData.account,
                    body.content.delegationData.id,
                    body.content.delegationData.parentId,
                    body.content.delegationData.permissions,
                    body.content.delegationData.isPCR,
                ],
                body.content.signatures.inviter,
                body.content.metaData,
            ];
            break;
        }
        case _1.default.BodyType.SUBMIT_ACCEPT_DELEGATION: {
            compressedContents = [
                [
                    body.content.delegationData.account,
                    body.content.delegationData.id,
                    body.content.delegationData.parentId,
                    body.content.delegationData.permissions,
                    body.content.delegationData.isPCR,
                ],
                [body.content.signatures.inviter, body.content.signatures.invitee],
            ];
            break;
        }
        case _1.default.BodyType.REJECT_ACCEPT_DELEGATION: {
            compressedContents = [
                body.content.account,
                body.content.id,
                body.content.parentId,
                body.content.permissions,
                body.content.isPCR,
            ];
            break;
        }
        case _1.default.BodyType.INFORM_CREATE_DELEGATION: {
            compressedContents = [body.content.delegationId, body.content.isPCR];
            break;
        }
        default:
            throw utils_1.SDKErrors.ERROR_MESSAGE_BODY_MALFORMED();
    }
    return [body.type, compressedContents];
}
exports.compressMessage = compressMessage;
/**
 * [STATIC] Takes a compressed [[Message]] and decompresses it depending on the message body type.
 *
 * @param body The body of the compressed [[Message]] which depends on the [[MessageBodyType]] that needs to be decompressed.
 *
 * @returns Returns the compressed message back to its original form and more human readable.
 */
function decompressMessage(body) {
    var _a;
    // body[0] is the [[MessageBodyType]] being sent.
    // body[1] is the content order of the [[compressMessage]] for each [[MessageBodyType]].
    // Each index matches the object keys from the given [[MessageBodyType]].
    let decompressedContents;
    switch (body[0]) {
        case _1.default.BodyType.REQUEST_TERMS: {
            decompressedContents = core_1.ClaimUtils.decompress(body[1]);
            break;
        }
        case _1.default.BodyType.SUBMIT_TERMS: {
            decompressedContents = {
                claim: core_1.ClaimUtils.decompress(body[1][0]),
                legitimations: body[1][1].map((attestedClaim) => !Array.isArray(attestedClaim)
                    ? attestedClaim
                    : core_1.AttestedClaimUtils.decompress(attestedClaim)),
                delegationId: body[1][2],
                quote: body[1][3]
                    ? core_1.QuoteUtils.decompressAttesterSignedQuote(body[1][3])
                    : undefined,
                prerequisiteClaims: body[1][4],
                cTypes: (_a = body[1][5]) === null || _a === void 0 ? void 0 : _a.map((val) => core_1.CTypeUtils.decompress(val)),
            };
            break;
        }
        case _1.default.BodyType.REJECT_TERMS: {
            decompressedContents = {
                claim: core_1.ClaimUtils.decompress(body[1][0]),
                legitimations: body[1][1].map((val) => core_1.AttestedClaimUtils.decompress(val)),
                delegationId: body[1][2] ? body[1][2] : undefined,
            };
            break;
        }
        case _1.default.BodyType.REQUEST_ATTESTATION_FOR_CLAIM: {
            decompressedContents = {
                requestForAttestation: core_1.RequestForAttestationUtils.decompress(body[1][0]),
                quote: body[1][1]
                    ? core_1.QuoteUtils.decompressQuoteAgreement(body[1][1])
                    : undefined,
                prerequisiteClaims: body[1][2]
                    ? body[1][2].map((claim) => core_1.ClaimUtils.decompress(claim))
                    : undefined,
            };
            break;
        }
        case _1.default.BodyType.SUBMIT_ATTESTATION_FOR_CLAIM: {
            decompressedContents = {
                attestation: core_1.AttestationUtils.decompress(body[1]),
            };
            break;
        }
        case _1.default.BodyType.REQUEST_CLAIMS_FOR_CTYPES: {
            decompressedContents = body[1].map((val) => {
                return {
                    cTypeHash: val[0],
                    acceptedAttester: val[1],
                    requiredProperties: val[2],
                };
            });
            break;
        }
        case _1.default.BodyType.SUBMIT_CLAIMS_FOR_CTYPES: {
            decompressedContents = body[1].map((attestedClaim) => !Array.isArray(attestedClaim)
                ? attestedClaim
                : core_1.AttestedClaimUtils.decompress(attestedClaim));
            break;
        }
        case _1.default.BodyType.REQUEST_ACCEPT_DELEGATION: {
            decompressedContents = {
                delegationData: {
                    account: body[1][0][0],
                    id: body[1][0][1],
                    parentId: body[1][0][2],
                    permissions: body[1][0][3],
                    isPCR: body[1][0][4],
                },
                signatures: { inviter: body[1][1] },
                metaData: body[1][2],
            };
            break;
        }
        case _1.default.BodyType.SUBMIT_ACCEPT_DELEGATION: {
            decompressedContents = {
                delegationData: {
                    account: body[1][0][0],
                    id: body[1][0][1],
                    parentId: body[1][0][2],
                    permissions: body[1][0][3],
                    isPCR: body[1][0][4],
                },
                signatures: {
                    inviter: body[1][1][0],
                    invitee: body[1][1][1],
                },
            };
            break;
        }
        case _1.default.BodyType.REJECT_ACCEPT_DELEGATION: {
            decompressedContents = {
                account: body[1][0],
                id: body[1][1],
                parentId: body[1][2],
                permissions: body[1][3],
                isPCR: body[1][4],
            };
            break;
        }
        case _1.default.BodyType.INFORM_CREATE_DELEGATION: {
            decompressedContents = {
                delegationId: body[1][0],
                isPCR: body[1][1],
            };
            break;
        }
        default:
            throw utils_1.SDKErrors.ERROR_MESSAGE_BODY_MALFORMED();
    }
    return { type: body[0], content: decompressedContents };
}
exports.decompressMessage = decompressMessage;
